// Day/night palette keyed by local hour (0..24, fractional allowed).
const STOPS: [number, [number, number, number]][] = [
  [0, [18, 24, 58]],
  [4, [30, 34, 90]],
  [6, [150, 92, 130]],
  [7.5, [246, 160, 110]],
  [9, [252, 214, 130]],
  [12, [255, 243, 190]],
  [15, [252, 214, 130]],
  [17.5, [246, 150, 100]],
  [19.5, [140, 80, 130]],
  [21, [50, 44, 100]],
  [24, [18, 24, 58]],
];

export function colorForHour(h: number): string {
  h = ((h % 24) + 24) % 24;
  let i = 0;
  while (i < STOPS.length - 2 && STOPS[i + 1][0] <= h) i++;
  const [h0, c0] = STOPS[i];
  const [h1, c1] = STOPS[i + 1];
  const t = h1 === h0 ? 0 : (h - h0) / (h1 - h0);
  const c = c0.map((v, k) => Math.round(v + (c1[k] - v) * t));
  return `rgb(${c[0]},${c[1]},${c[2]})`;
}

/** Whether light text is readable on the colour for this hour. */
export function isDarkHour(h: number): boolean {
  h = ((h % 24) + 24) % 24;
  return h < 6.5 || h >= 19;
}
